import { 
  Flex,
  Icons, 
  IconsProps,
} from "@components/index";

import style from "./CardFilter.module.scss";

interface CardFilterProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: IconsProps["icon"];
  label: string;
  value: number;
  select?: boolean;
}

const CardFilter: React.FC<CardFilterProps> = ({ 
  icon, 
  label, 
  value, 
  select, 
  className, 
  onClick,
}) => (
  <Flex.Row 
    gap="8px" 
    flexWrap="nowrap" 
    alignItems="center" 
    onClick={onClick}
    className={`${style.card} ${select && style.select}`} 
  >
    <Icons icon={icon} style={{ fontSize: "30px" }} className={className} />
    <span className="text text--lg no-select">{label}</span>
    <span className="text text--lg no-select bold" style={{ width: "auto" }}>{value}</span>
  </Flex.Row>
);

export default CardFilter;